import i18n from 'scoreboard/components/i18n'
import unwrapModel from 'scoreboard/components/unwrap-model'

/**
 * Returns a default set of options relevant for creating a ObjectSelectorButton
 * to select a dataset.
 *
 * @param {Dataset|Object} [dataset] - the initially selected dataset
 */
function forButton ({ dataset } = {}) {
	return {
		section: 'datasets',
		domainObject: dataset ? unwrapModel(dataset) : null,
		objectSelectorOptions: {
			title: i18n.get('datasets.choose'),
			objectParams: {
				// ensures that dataset views aren't in the tree
				topLevelOnly: true
			}
		},
		testSelectedObject: testRealDataset
	}
}
/**
 * Returns a default set of options relevant for creating an ObjectSelector
 * or ObjectSelectorForm to select a dataset.
 */
function forSelector () {
	return {
		section: 'datasets',
		showProjectSelector: true,
		objectParams: {
			// ensures that dataset views aren't in the tree
			topLevelOnly: true
		},
		testSelectedObject: testRealDataset
	}
}

/**
 * Validation function to test if the dataset selected from the tree is a
 * "real" dataset (ie not a folder or view)
 *
 * @return {String} an error message if the selected node is not a "real" dataset
 */
function testRealDataset (selected) {
	// ensures that folders can't be selected
	if (!selected || selected.type !== 'dataset') {
		return i18n.get('common.error.mustSelect.dataset')
	}
}

export { forButton }
export { forSelector }
export { testRealDataset }
